import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import Wages from "./Wages";
import Discount from "./Discount";
import PaintPrice from "./PaintPrice";
import Shipping from "./Shipping";
import Passpartout from "./Passpartout";

const Cash = () => {
    return (
        <>
            <div className="w-full flex flex-col">
                <Tabs aria-label="Options" className="border-b pb-3">
                    <Tab key="paint" title="تابلو">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <PaintPrice />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="passpartout" title="پاسپارتو">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Passpartout />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="wages" title="اجرت">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Wages />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="discount" title="کد تخفیف">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Discount />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="shipping" title="هزینه ارسال">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <Shipping />
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        </>
    );
};

export default Cash;